import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../../redux/errors.slice"
import { type RootState } from "../../../../store.ts"
import { showResponseMessage } from "../../../../utils/handlers/show-response-message.ts"
import {
  deleteAttachment,
  uploadAttachment
} from "../../../Album/api/attachment.services"
import { albumSliceName } from "../../../Album/redux/album.constants.ts"
import {
  type Attachment,
  type AttachmentModels,
  type AttachmentParentModels,
  type AttachmentUploadData
} from "../../../Album/types/attachment.types.ts"
import { updateModelAttachments } from "./project-attachments.helpers.ts"

export const uploadProjectAttachment = createAsyncThunk<
  Attachment,
  { data: AttachmentUploadData; signal?: AbortSignal; silent?: boolean }
>(
  `${albumSliceName}/uploadAttachment`,
  async (
    { data: { parent_type, ...rest }, signal, silent },
    { dispatch, getState, rejectWithValue }
  ) => {
    const response = await uploadAttachment(rest, signal)
    if (!response.ok) {
      if (!silent) dispatch(errorSave(response?.data?.details))
      return rejectWithValue(response.data)
    }

    const attachment = response?.data?.details?.data as Attachment

    updateModelAttachments(dispatch, getState() as RootState, {
      object_id: rest.object_id,
      model_type: rest.model_type,
      parent_type,
      action: "add",
      attachment
    })

    if (!silent)
      showResponseMessage(response, "Attachment uploaded successfully.")
    return attachment
  }
)

export const deleteProjectAttachment = createAsyncThunk<
  void,
  {
    attachment_id: string
    object_id: string
    model_type: AttachmentModels
    parent_type?: AttachmentParentModels
  }
>(
  `${albumSliceName}/deleteAttachment`,
  async (
    { attachment_id, object_id, model_type, parent_type },
    { dispatch, getState, rejectWithValue }
  ) => {
    const response = await deleteAttachment(attachment_id)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details))
      return rejectWithValue(response.data)
    }

    updateModelAttachments(dispatch, getState() as RootState, {
      object_id,
      model_type,
      parent_type,
      action: "remove",
      attachment_id
    })

    showResponseMessage(response, "Attachment deleted successfully.")
  }
)
